import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface DeleteFromShuffleResponse extends MiddlewareAPIResponse
{
    
}

export class DeleteFromShuffleResponseDtoImpl extends MiddlewareDtoImpl implements DeleteFromShuffleResponse
{
   
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/mytunes/deletefromshuffle/deletefromshuffleresponse.tsx